// extracted by mini-css-extract-plugin
export default {"card":"MaxCard_card__T6ZHQ","copy":"MaxCard_copy__x6fd7","title":"MaxCard_title__sYiEQ","desc":"MaxCard_desc__unrD9","open":"MaxCard_open__FejMm","qr":"MaxCard_qr__g8sq4"};